import { useMemo } from 'react';
import { useAtomValue } from 'jotai';
import { AssemblyId } from '@/types';
import { structureRelationships, structures } from './atoms';

export const useAssemblyInfoFromAssemblyId = (assemblyId: AssemblyId) => {
  const structureRelationshipsValue = useAtomValue(structureRelationships);

  const assemblyInfo = useMemo(
    () => structureRelationshipsValue?.byAssemblyId.get(assemblyId),
    [assemblyId, structureRelationshipsValue?.byAssemblyId]
  );

  return assemblyInfo;
};

export const useStructureStatusFromId = (inspectionId: string) => {
  const structuresQueryResult = useAtomValue(structures);

  const structureStatus = useMemo(() => {
    const status = structuresQueryResult.find((structure) => structure.id === inspectionId)?.status;
    return status;
  }, [inspectionId, structuresQueryResult]);

  return structureStatus;
};
